import { h } from 'preact';
import { showModal, Toast } from 'utils/modal';
import { joinClasses } from 'utils/utils';

import Button from 'components/button/button';
import WithTooltip from 'components/tooltip/withTooltip';

import s from 'components/media/uploadManagerToast.sss';

let currentManager = null;

const Progress = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props} class={joinClasses(s.progress, props.class)}>
		<circle class={s.outer} cx="10" cy="10" r="8.35" stroke-width="1.25" stroke-linecap="round" pathLength="1" />
		<path class={s.tick} d="M6 10.5L8.5 13L13.5 8" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" pathLength="1" />
		{/* <path class={s.cross} d="M7 7L13 13M13 7L7 13" stroke-width="1.25" stroke-linecap="round" pathLength="1" /> */}
		<path class={s.exclamation} d="M10 6.5V13.5" stroke-width="1.25" stroke-linecap="round" pathLength="1" />
	</svg>
);

export class UploadManagerToast extends Toast {
	s = s;

	id = 'upload-manager';

	keep = true;

	constructor(props) {
		super(props);
		this.state = { collapsed: false, uploads: [] };
		this.toggleCollapsed = this.toggleCollapsed.bind(this);
		this.renderUpload = this.renderUpload.bind(this);

		this.addUploads(props.uploads);
	}

	componentDidMount() {
		super.componentDidMount?.();
		if (!currentManager) currentManager = this;
		this.props.uploads?.forEach(upload => {
			upload.addEventListener('update', () => this.setState({}));
		});
	}

	onToggle(e) {
		super.onToggle?.(e);
		if (e.newState === 'closed' && currentManager === this) {
			currentManager = null;
		}
	}

	addUploads(uploads) {
		if (!Array.isArray(uploads) || !uploads.length) return;
		this.setState({ uploads: this.state.uploads.concat(uploads) });
		uploads?.forEach(upload => upload.addEventListener('update', () => this.setState({})));
	}

	toggleCollapsed() {
		this.setState({ collapsed: !this.state.collapsed });
	}

	getTotalProgress(uploads = this.state.uploads) {
		const validUploads = uploads?.filter(upload => !upload.error) || [];
		if (!validUploads.length) return 1;
		const progress = validUploads.reduce((acc, upload) => acc + upload.progress, 0);
		return progress / validUploads.length;
	}

	getTitle(uploads = this.state.uploads) {
		if (uploads?.every(u => u.processed || u.error)) {
			if (uploads.some(u => u.error)) {
				return 'Some uploads failed';
			}
			return 'Upload complete';
		}
		return 'Uploading files...';
	}

	renderHeader() {
		const totalProgress = this.getTotalProgress();
		return (
			<div class={joinClasses(s.header, this.state.collapsed && s.collapsed, totalProgress >= 1 && s.done)} key="header">
				<div class={s.title}>{this.getTitle()}</div>
				<div class={s.buttons}>
					<Button icon="chevron-down" class={s.collapse} onClick={this.toggleCollapsed} />
					<div class={s.close}>
						<Button icon="cancel" onClick={this.close} />
						<Progress style={`--progress: ${totalProgress};`} />
					</div>
				</div>
			</div>
		);
	}

	renderUpload(upload) {
		let processing = upload.progress >= 1 && !upload.processed && !upload.error;
		return (
			<div class={joinClasses(s.upload, processing && s.processing)} key={upload.id}>
				<div class={s.name}>{upload.name}</div>
				<div class={s.status}>
					<WithTooltip tooltip={upload.error} direction="top">
						<Progress class={joinClasses(processing && s.indeterminate, upload.error && s.error)} style={`--progress: ${upload.progress};`} />
					</WithTooltip>
				</div>
			</div>
		);
	}

	renderUploads() {
		const uploads = this.state.uploads || [];
		return (
			<div class={joinClasses(s.uploads, this.state.collapsed && s.collapsed)} key="uploads">
				{uploads?.map(this.renderUpload)}
			</div>
		);
	}

	renderInner() {
		return [
			this.renderHeader(),
			this.renderUploads(),
		];
	}
}

export async function showUploadManager(uploads, mountPoint) {
	if (!uploads?.length) return;
	if (currentManager) {
		return currentManager.addUploads(uploads);
	}
	await showModal(UploadManagerToast, { uploads, stubborn: true }, { mountPoint });
}